import "./index.scss";
import React from "react";

import {
  Avatar,
  OverseasMark,
  RatingBadge,
  RolePill,
  money,
  present,
  shortName,
} from "../atoms";

// Who is on the block. An inset card inside the page's white panel: the name
// and the base price are the only strong text, everything describing them
// drops back to a muted label.
const PlayerDetails = ({ player, isCurator, className = "" }) => {
  const name = player?.name;
  const display = isCurator ? name || "—" : shortName(name);

  // The men's pool carries no mentality and no rating, and a keeper has no
  // bowling style, so every one of these is optional. "NA" counts as absent
  // because that is how the source sheet spells it, and a rating of 0 means
  // unrated rather than worst.
  const facts = [
    ["Batting", player?.battingHanded],
    ["Bowling", player?.bowlingHanded],
    ["Batting style", player?.battingMentality],
    ["Bowling style", player?.bowlingMentality],
  ].filter(([, value]) => present(value));

  return (
    <section className={`player-card ${className}`}>
      <header className="player-card-head">
        <Avatar name={name} src={player?.image} size={44} />
        <div className="player-card-title">
          <h2 className="player-card-name">
            {display}
            <OverseasMark nationality={player?.nationality} />
          </h2>
          <div className="player-card-tags">
            <RolePill role={player?.role} />
            <RatingBadge value={player?.rating} />
          </div>
        </div>
      </header>

      {facts.length > 0 && (
        <dl className="player-card-facts">
          {facts.map(([label, value]) => (
            <div key={label} className="player-card-fact">
              <dt className="au-label">{label}</dt>
              <dd>{value}</dd>
            </div>
          ))}
        </dl>
      )}

      <footer className="player-card-foot">
        <span className="au-label">Base price</span>
        <span className="player-card-base">{money(player?.basePrice)}</span>
      </footer>
    </section>
  );
};

export default PlayerDetails;
